import isDevelopment from "../../utils/isDevelopment";

export default ({ children, and = true }) =>
  isDevelopment() && and ? children : null;
